<div [ngClass]="getClasses()" [innerHtml]="widget.data.text|safe"></div>
